/**
 * O anel do relógio da sessão no botão da mesa, na barra da esquerda (docs/spec/session-clock.md):
 * uma volta por hora de jogo, verde correndo e âmbar em pausa, com os minutos embaixo. Aparece de
 * qualquer tela, também nas mesas abertas em segundo plano.
 */
import { playAnchor, ringView, type RoomClock } from './clockModel.js';
import { useServerNow } from './useServerNow.js';
import './clock.css';

/** O retângulo arredondado em volta do avatar (40×40 dentro de 48×48), começando no meio do alto. */
const RING_PATH = 'M24 1.5H39.5A7 7 0 0 1 46.5 8.5V39.5A7 7 0 0 1 39.5 46.5H8.5A7 7 0 0 1 1.5 39.5V8.5A7 7 0 0 1 8.5 1.5Z';

/** O anel da mesa (null sem sessão aberta). Os minutos bastam: anda a cada 15 s, na virada do minuto. */
export function useClockRing(clock: RoomClock | null | undefined): ReturnType<typeof ringView> {
  const session = clock?.session ?? null;
  const now = useServerNow(session?.status === 'running', 15_000, session ? playAnchor(session) : 0);
  return ringView(clock, now);
}

export function ClockRingArc({ progress, paused }: { progress: number; paused: boolean }) {
  return (
    <svg className={`rd-clockRing${paused ? ' is-paused' : ''}`} viewBox="0 0 48 48" aria-hidden="true">
      <path className="rd-clockRing__track" d={RING_PATH} />
      <path className="rd-clockRing__arc" d={RING_PATH} pathLength={1} strokeDasharray={`${progress} 1`} />
    </svg>
  );
}
